// Auto-generated by cli/scripts/generate-schema-version.js
export const SCHEMA_VERSION = "1.12.2";
